import React, { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'
import SelectGroup from '@node-space/storybook-components/dist/SelectGroup'
import { BusinessDetailsPayload } from 'types/verification'
import { getIndustryName } from 'utils/utils'

export interface VerticalContextType {
  businessDetails: BusinessDetailsPayload
  industryOptions: SelectGroup[]
  industryName: string
  isIndustryConfirmed: boolean
  setBusinessDetails: Dispatch<SetStateAction<BusinessDetailsPayload>>
  setIndustryOptions: Dispatch<SetStateAction<SelectGroup[]>>
  setIsIndustryConfirmed: Dispatch<SetStateAction<boolean>>
}

export interface VerticalContextProviderProps {
  children: ReactNode
}

export const verticalContextDefaultValues = {
  businessDetails: null,
  industryOptions: [],
  industryName: '',
  isIndustryConfirmed: false,
  setBusinessDetails: () => null,
  setIndustryOptions: () => null,
  setIsIndustryConfirmed: () => null,
}

export const VerticalContext = createContext<VerticalContextType>(verticalContextDefaultValues)

export const VerticalContextProvider = ({ children }: VerticalContextProviderProps) => {
  const [businessDetails, setBusinessDetails] = useState<BusinessDetailsPayload>()
  const [industryOptions, setIndustryOptions] = useState<SelectGroup[]>([])
  const [isIndustryConfirmed, setIsIndustryConfirmed] = useState(false)

  const industryName = getIndustryName(businessDetails?.industryReference, industryOptions) ?? ''

  return (
    <VerticalContext.Provider
      value={{
        businessDetails,
        industryOptions,
        industryName,
        isIndustryConfirmed,
        setBusinessDetails,
        setIndustryOptions,
        setIsIndustryConfirmed,
      }}
    >
      {children}
    </VerticalContext.Provider>
  )
}
